<mat-card>
  <mat-card-title>
    <mat-icon *ngIf="matIcon">{{matIcon}}</mat-icon>
    {{cardTitle}}
  </mat-card-title>
  <ng-content></ng-content>
</mat-card>

